import * as React from 'react';

interface NavigationProps extends React.HTMLAttributes<HTMLElement> {
}

const Navigation = React.forwardRef<HTMLElement, NavigationProps>((
    {
        children
    },
    ref
): React.ReactElement => (
    <nav
        ref={ref}
        className="softphone-navigation"
    >
        {children}
    </nav>
));

Navigation.displayName = 'Navigation';

export default Navigation;
